var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiggerDerrick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3941 18.8537V25.3493H24.9792V16.1791L10.4598 7.20001H3.77319V11.7851H9.31349L20.3941 18.8537Z",
    fill: "#575656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49243 32.2268V11.0209H6.6387V32.2268C6.6387 32.5434 6.3821 32.8 6.06557 32.8C5.74903 32.8 5.49243 32.5434 5.49243 32.2268Z",
    fill: "#575656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63892 23.4389C6.63892 23.7554 6.38232 24.012 6.06578 24.012H3.77324C3.45671 24.012 3.20011 23.7554 3.20011 23.4389C3.20011 23.1223 3.45671 22.8657 3.77324 22.8657H6.06578C6.38232 22.8657 6.63892 23.1223 6.63892 23.4389Z",
    fill: "#575656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63892 26.9732C6.63892 27.2897 6.38232 27.5463 6.06578 27.5463H3.77324C3.45671 27.5463 3.20011 27.2897 3.20011 26.9732C3.20011 26.6566 3.45671 26.4 3.77324 26.4H6.06578C6.38232 26.4 6.63892 26.6566 6.63892 26.9732Z",
    fill: "#575656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63892 29.9343C6.63892 30.2509 6.38232 30.5075 6.06578 30.5075H3.77324C3.45671 30.5075 3.20011 30.2509 3.20011 29.9343C3.20011 29.6178 3.45671 29.3612 3.77324 29.3612H6.06578C6.38232 29.3612 6.63892 29.6178 6.63892 29.9343Z",
    fill: "#575656"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93115 21.7281C8.93115 22.0446 8.67455 22.3012 8.35802 22.3012H6.06548C5.74895 22.3012 5.49235 22.0446 5.49235 21.7281C5.49235 21.4116 5.74895 21.155 6.06548 21.155H8.35802C8.67455 21.155 8.93115 21.4116 8.93115 21.7281Z",
    fill: "#575656"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93115 25.2277C8.93115 25.5442 8.67455 25.8008 8.35802 25.8008H6.06548C5.74895 25.8008 5.49235 25.5442 5.49235 25.2277C5.49235 24.9111 5.74895 24.6545 6.06548 24.6545H8.35802C8.67455 24.6545 8.93115 24.9111 8.93115 25.2277Z",
    fill: "#575656"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9314 28.7881C8.9314 29.1046 8.6748 29.3612 8.35826 29.3612H6.06573C5.74919 29.3612 5.49259 29.1046 5.49259 28.7881C5.49259 28.4716 5.74919 28.215 6.06573 28.215H8.35826C8.6748 28.215 8.9314 28.4716 8.9314 28.7881Z",
    fill: "#575656"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2626 12.9309C32.7891 12.909 33.7613 13.2162 34.6287 14.5072C35.4076 15.6664 36.0928 17.6155 36.227 20.7642H34.8005C32.0139 20.7642 29.755 18.5053 29.755 15.7188V12.9314H32.2507L32.2626 12.9309ZM28.4179 11.7851V11.7851H32.2276C33.2279 11.7487 34.5415 12.322 35.5802 13.8679C36.5172 15.2625 37.2392 17.4513 37.3742 20.7642H37.3968V21.8075C37.3969 21.8417 37.397 21.8761 37.397 21.9105H37.3968V29.9344H34.8177C34.2063 31.4999 32.6833 32.609 30.9013 32.609C29.1192 32.609 27.5962 31.4999 26.9848 29.9344H19.1522C18.5408 31.4999 17.0177 32.609 15.2357 32.609C12.9145 32.609 11.0327 30.7273 11.0327 28.406C11.0327 26.1488 12.812 24.3072 15.0446 24.2073V24.203H15.2293L15.2357 24.203L15.2421 24.203H24.7878V11.7851H28.4179ZM30.9014 30.6986C32.1676 30.6986 33.194 29.6722 33.194 28.406C33.194 27.1399 32.1676 26.1135 30.9014 26.1135C29.6353 26.1135 28.6089 27.1399 28.6089 28.406C28.6089 29.6722 29.6353 30.6986 30.9014 30.6986ZM17.5281 28.406C17.5281 29.6722 16.5017 30.6986 15.2356 30.6986C13.9694 30.6986 12.943 29.6722 12.943 28.406C12.943 27.1399 13.9694 26.1135 15.2356 26.1135C16.5017 26.1135 17.5281 27.1399 17.5281 28.406Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiggerDerrick);
export default __webpack_public_path__ + "static/media/DIGGER_DERRICK.22486eadc33dc963b81749e4d0da15e3.svg";
export { ForwardRef as ReactComponent };